function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9.5,
  stroke: "#B5B5B5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 15.917c0-.129.03-.333.09-.611.035-.16.088-.371.158-.634l.923-3.559c.01-.041.017-.082.022-.123a.49.49 0 00.015-.117c0-.211-.065-.342-.195-.394-.13-.052-.368-.085-.713-.1V9.96c.29-.021.71-.062 1.261-.124.555-.067.948-.124 1.178-.17l.66-.132-1.193 4.51c-.1.387-.167.655-.202.805-.09.381-.135.629-.135.742 0 .114.025.188.075.224.05.031.105.047.165.047.155 0 .348-.137.578-.41.23-.273.432-.56.608-.859l.337.225c-.5.758-.883 1.268-1.148 1.531-.435.433-.9.65-1.396.65-.28 0-.533-.088-.758-.263-.22-.18-.33-.454-.33-.82zM12.972 6c.285 0 .528.103.728.31.2.206.3.456.3.75s-.1.546-.3.758a.977.977 0 01-.728.31 1 1 0 01-.736-.31c-.2-.212-.3-.464-.3-.758s.1-.544.3-.75a1 1 0 01.736-.31z",
  fill: "#A8A8A8"
});

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.65bdc94b.svg";
export { ForwardRef as ReactComponent };